module.exports = __webpack_public_path__ + "img/wl.9332fe06.jpg";